module.exports = __webpack_public_path__ + "static/media/wind-turbine.6380621e.svg";